
import React from "react";
import { BaseService, IProfile, ITransaction, PloutousStatus, SanitizedResponse, TransactionAcknowledgementService } from "../../../../../services";
import { ButtonManageRef, ObjectHelper, Scheme } from "@rivtn/noseur";
import { ConfirmDialog, Elements, Siren } from "../../../../shared";
import { i18nManager } from "../../../../../i18n";
import { Utils } from "../../../../../utils";

export interface AcceptRejectTransactionProps {
    onComplete: () => void;
    transaction: ITransaction;
    type: "accept_transaction" | "reject_transaction";
}

export function AcceptRejectTransaction(props: AcceptRejectTransactionProps) {

    let dialogErrorRef: any;
    const { transaction, type, onComplete } = props;
    const labels = i18nManager.Labels.dashboard.ploutous.transactions.dialogs[type];
    const transactionAcknowledgementService = TransactionAcknowledgementService.getInstance();
    const amount = Utils.makeToMoney(transaction.amount_paid - (transaction.acknowledged_amount + transaction.refunded_amount));
    const acknowledgementPayload = {
        amount,
        type: "FULL",
        business_id: transaction.business_id,
        transaction_reference: transaction.reference,
        description: "Acknowledged by Rivtn Administrator on business behalf",
        acknowledgement_reference: "RA" + Utils.randomString(20, "0123456789"),
        status_code: (type === "accept_transaction" ? PloutousStatus.TRANSACTION_ACKNOWLEDGE_ACCEPTED : PloutousStatus.TRANSACTION_ACKNOWLEDGE_REJECTED),
    };

    const dialog = ConfirmDialog({
        closable: true,
        title: labels.title,
        confirmLabel: labels.confirm_label,
        confirmScheme: (type === "reject_transaction" ? Scheme.DANGER : undefined),
        desc: ObjectHelper.expandStringTemplate(labels.desc, {
            reference: transaction.reference,
            business_service: (`${transaction.extra_data?.business_name ?? ''} (${transaction.extra_data?.service_name ?? ''})`)
        }, { chop: "$" }),
        content: (<div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            {Elements.buildConfirmDialogForm(labels.form, (name, value) => {
                dialogErrorRef.innerText = " ";
                (acknowledgementPayload as any)[name] = parseFloat(value ? value : 0);
                return false;
            }, acknowledgementPayload, undefined, { marginTop: 0 })}
            <div ref={(r) => { dialogErrorRef = r; }} className="error" style={{ marginBottom: 0 }}> </div>
        </div>),
        onConfirm: (confirmButton?: ButtonManageRef) => {
            confirmButton?.setLoadingState(true);
            const microAmount = acknowledgementPayload.amount * 1000;
            acknowledgementPayload.type = (microAmount ? "FULL" : "PARTIAL");
            transactionAcknowledgementService.acknowledge({ ...acknowledgementPayload, amount: microAmount }).then(({ apiResponse }: SanitizedResponse<any>) => {
                dialog.destroy(async () => {
                    Siren.alert(apiResponse.message);
                    await onComplete();
                });
            }).catch((err: any) => {
                BaseService.reportError(err);
                dialogErrorRef.innerText = err?.message ?? err;
            }).finally(() => {
                confirmButton?.setLoadingState(false);
            });
            return false;
        },
    });
    return dialog;
}
